/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Route } from 'react-router-dom';
import Map from 'pages/map/index';
import Dashboard from 'routes/dashboard';
import WhatsNextRoom from 'pages/whatsNextRoom/index';
import DigitalResourceMap from 'pages/digitalResourceMap';
import Onboarding from 'routes/onboarding';
import Steps from 'pages/steps/index';
import StepsAdminCorner from 'pages/steps/stepsAdminCorner';
import SwitchTemplate from 'pages/switchTemplate';
import SuccessfulRegistration from 'pages/successfulRegistration';
import Congratulations from 'pages/congratulations';

const getProtectedRoutes = (
  hasChildren: boolean,
  userType: string,
  isActiveSubscription: boolean
): JSX.Element[] => {
  let routes: any = [];
  if (userType === 'parent' && !isActiveSubscription) {
    routes = [
      <Route key="dashboard" path="/dashboard">
        <Dashboard isActiveSubscription={isActiveSubscription} />
      </Route>,
    ];
  }
  if (userType === 'parent' && isActiveSubscription) {
    routes = [
      <Route key="onboarding" path="/onboarding">
        <Onboarding userType={userType} hasChildren={hasChildren} />
      </Route>,
      <Route key="dashboard" path="/dashboard">
        <Dashboard isActiveSubscription={isActiveSubscription} />
      </Route>,
      <Route key="process-steps" path="/process-steps">
        <Steps />
      </Route>,
      <Route key="process-steps-admin" path="/process-steps-admin">
        <StepsAdminCorner />
      </Route>,
      <Route key="map" path="/map">
        <Map />
      </Route>,
      <Route key="digital-map" path="/digital-map">
        <DigitalResourceMap />
      </Route>,
      <Route key="switch-map" path="/switch-map">
        <SwitchTemplate />
      </Route>,
      <Route key="сongratulations" path="/сongratulations">
        <Congratulations />
      </Route>,
      <Route key="next-room" path="/next-room">
        <WhatsNextRoom />
      </Route>,
      <Route key="registered" path="/registration-success">
        <SuccessfulRegistration />
      </Route>,
    ];
  }
  if (userType === 'teacher') {
    routes = [
      <Route key="onboarding" path="/onboarding">
        <Onboarding hasChildren={hasChildren} userType={userType} />
      </Route>,
      <Route key="dashboard" path="/dashboard">
        <Dashboard isActiveSubscription />
      </Route>,
      <Route key="process-steps-admin" path="/process-steps-admin">
        <StepsAdminCorner />
      </Route>,
      <Route key="сongratulations" path="/сongratulations">
        <Congratulations />
      </Route>,
      <Route key="registered" path="/registration-success">
        <SuccessfulRegistration />
      </Route>,
    ];
  }
  return routes;
};

export default getProtectedRoutes;
